// extracted by mini-css-extract-plugin
module.exports = {"TrackInfo":"TrackInfo_TrackInfo__2bSjj","Title":"TrackInfo_Title__2lML1"};